import * as types from '../types'

export function loadProjectList(projects) {
  return {
    type: types.FETCH_DB_PROJECT_LIST,
    payload:{
        "projects":projects
    }
  };
}

export function loadDbTablesList(list) {
  return {
    type: types.FETCH_DB_TABLES_LIST,
    payload:{
        "databaseList":list.data,
        "totalRecords": list.noOfRecords
    }
  };
}
export function loadDbPermissionDetail(list, projectList) {
  return {
    type: types.FETCH_LIB_PERMISSION_DETAIL,
    payload:{
        "permissionDetail":list,
        "projectList":projectList,
    }
  };
}
export function loadDbGetPermission(data) {
  return {
    type: types.FETCH_LIB_GET_PERMISSION,
    payload:{
        "getPermissionResp":data
    }
  };
}

